var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.86 53.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#5ec8dc;}.cls-2{fill:#9cc2d7;}.cls-3{fill:#c1e7ef;}.cls-4{fill:#037bc1;}.cls-5{fill:#fff;}.cls-6{fill:#ef4161;}.cls-7{fill:#ffffff;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.27,
    y: 22.28,
    width: 30.53,
    height: 30.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 13.04,
    width: 14.69,
    height: 14.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.03,
    width: 9.49,
    height: 9.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.81,
    y: 3.03,
    width: 4.87,
    height: 4.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.92 35.34 24.98 40.63 22.66 31.03 20.23 38.07 15.06 37.92 15.72 38.68 20.75 38.82 22.54 33.66 24.83 43.18 27.01 37.23 27.68 38.62 33.44 38.62 34.07 37.88 28.15 37.88 26.92 35.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29,27.45a6.44,6.44,0,0,0-4.41,1.73v-.06s0,0,0,0,0,0,0,0v.06h0A6.51,6.51,0,0,0,13.58,34a6.34,6.34,0,0,0,1.48,4l5.17.15,2.43-7L25,40.63l1.94-5.29,1.23,2.55h5.92A6.45,6.45,0,0,0,35.5,34,6.51,6.51,0,0,0,29,27.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27,37.23l-2.18,6-2.29-9.52-1.79,5.16-5-.14c.2.21.41.41.62.6,2.11,1.93,7.57,7.71,8.18,8.36l8.23-8.35c.24-.22.47-.43.69-.67H27.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.7,39.75H48.23v8.51H43.94V27.44h4.29v8.33h2l5.09-8.33h5.23l-6.42,9.85,7.1,11H56.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.59,44H67.06l-1.43,4.29H61.07l7.75-20.82h4l7.79,20.82H76Zm-6.37-3.48h5.21L70.81,32.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.83,40.92v7.34H82.54V27.44h8.12a9.33,9.33,0,0,1,4.13.86,6.36,6.36,0,0,1,2.74,2.43,6.91,6.91,0,0,1,1,3.6,6,6,0,0,1-2.09,4.83,8.77,8.77,0,0,1-5.8,1.76Zm0-3.47h3.83a3.8,3.8,0,0,0,2.6-.8,3,3,0,0,0,.89-2.29,3.41,3.41,0,0,0-.9-2.47,3.37,3.37,0,0,0-2.49-1H86.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M117.33,53.38h-4V48.26H100.81v5.1H96.75l-.23-8.55H98.1a6.73,6.73,0,0,0,2-3.11,21,21,0,0,0,.94-5.08l.6-9.18h13.64V44.81h2.43ZM103,44.81H111V30.91h-5.27l-.36,5.48Q104.89,41.9,103,44.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.48,48.26h-4.29V27.44h4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.56,38.32a12.47,12.47,0,0,1-1.09,5.39,8.14,8.14,0,0,1-3.11,3.58,8.58,8.58,0,0,1-4.64,1.26,8.69,8.69,0,0,1-4.62-1.25A8.25,8.25,0,0,1,129,43.75a12.14,12.14,0,0,1-1.13-5.32v-1A12.51,12.51,0,0,1,128.94,32a8.21,8.21,0,0,1,3.13-3.59,9.18,9.18,0,0,1,9.25,0A8.28,8.28,0,0,1,144.45,32a12.46,12.46,0,0,1,1.11,5.4Zm-4.35-.94a8.77,8.77,0,0,0-1.17-5,4.15,4.15,0,0,0-6.68,0,8.66,8.66,0,0,0-1.19,4.92v1a8.88,8.88,0,0,0,1.18,5,4.1,4.1,0,0,0,6.69.06,8.83,8.83,0,0,0,1.17-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.64,48.26h-4.31V30.91H153V48.26h-4.29V27.44h16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.69,40.92v7.34H169.4V27.44h8.12a9.3,9.3,0,0,1,4.13.86,6.36,6.36,0,0,1,2.74,2.43,6.91,6.91,0,0,1,1,3.6,6,6,0,0,1-2.09,4.83,8.77,8.77,0,0,1-5.8,1.76Zm0-3.47h3.83a3.8,3.8,0,0,0,2.6-.8,3,3,0,0,0,.89-2.29,3.41,3.41,0,0,0-.9-2.47,3.37,3.37,0,0,0-2.49-1h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M205.39,38.32a12.62,12.62,0,0,1-1.08,5.39,8.2,8.2,0,0,1-3.11,3.58,9.17,9.17,0,0,1-9.26,0,8.2,8.2,0,0,1-3.15-3.55,12.28,12.28,0,0,1-1.13-5.32v-1A12.51,12.51,0,0,1,188.77,32a8.28,8.28,0,0,1,3.13-3.59,9.18,9.18,0,0,1,9.25,0A8.3,8.3,0,0,1,204.29,32a12.61,12.61,0,0,1,1.1,5.4Zm-4.34-.94a8.68,8.68,0,0,0-1.18-5,3.79,3.79,0,0,0-3.34-1.7,3.85,3.85,0,0,0-3.34,1.68A8.67,8.67,0,0,0,192,37.3v1a8.88,8.88,0,0,0,1.17,5A3.82,3.82,0,0,0,196.56,45a3.76,3.76,0,0,0,3.31-1.7,8.74,8.74,0,0,0,1.18-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M224.86,41.32a7.39,7.39,0,0,1-2.48,5.29,8.72,8.72,0,0,1-5.9,1.94,7.83,7.83,0,0,1-6.3-2.7,11.05,11.05,0,0,1-2.3-7.4V37.18a12.37,12.37,0,0,1,1.06-5.29,8,8,0,0,1,3-3.52,9.47,9.47,0,0,1,10.38.71,7.94,7.94,0,0,1,2.55,5.42H220.6a4.33,4.33,0,0,0-1.13-2.92,4.13,4.13,0,0,0-2.94-.91,3.63,3.63,0,0,0-3.21,1.54A8.61,8.61,0,0,0,212.23,37v1.57a9.23,9.23,0,0,0,1,4.93A3.58,3.58,0,0,0,216.48,45a4.2,4.2,0,0,0,3-.91,4.08,4.08,0,0,0,1.13-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242.93,30.91h-6.38V48.26h-4.29V30.91H226V27.44h17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M249.94,48.26h-4.29V27.44h4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M258.21,40.92v7.34h-4.29V27.44H262a9.25,9.25,0,0,1,4.12.86,6.31,6.31,0,0,1,2.74,2.43,6.83,6.83,0,0,1,1,3.6,6,6,0,0,1-2.1,4.83A8.74,8.74,0,0,1,262,40.92Zm0-3.47H262a3.77,3.77,0,0,0,2.59-.8,2.92,2.92,0,0,0,.9-2.29,3.41,3.41,0,0,0-.9-2.47,3.37,3.37,0,0,0-2.49-1h-3.93Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLast);
export default __webpack_public_path__ + "static/media/logo-last.9432c6dc.svg";
export { ForwardRef as ReactComponent };